var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReproduction = function SvgReproduction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 64,
    height: 64
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 8.6c12.9 0 23.4 10.5 23.4 23.4S44.9 55.4 32 55.4 8.6 44.9 8.6 32 19.1 8.6 32 8.6M32 7C18.2 7 7 18.2 7 32s11.2 25 25 25 25-11.2 25-25S45.8 7 32 7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 26.1c2 .1 4-.8 5.8-.9 3.1-.2 5.9.3 7.9 1.9 4.5 3.3 3.8 6.2 1.9 8.9-1.2-.3-.3-3-.4-4.2-.1-1.1-.6-1.7-1.1-1.6-.1 1.1-.2 2.1-.6 2.6 0 .9-.1 2.3.3 2.3.9.4 1.1 1 .6 1.9-.4.7-.8 1.5-1.2 2.2s-1 1.2-2.1 1c-.7.9-2.3 1.7-3.8 1.4-.3-.1-.5-.1-.6-.3.2-.6.2-1.3 1.8-1.5.5-.4.9-.8 1.3-1.2.7-1.2.2-1.9-.5-2.5-.7-.5-1.2-1.1-1.6-1.9-1 .5-2 .7-3 .5-.6 2.2-1 4.4-1.4 5.7-.1.3-.3.5-.5.7-.5.5-.9.8-1.5.5-.5.7-1.2 1-2.1.8-.3-.1-.6-.1-.7-.4.1-.6.3-1.2 1.7-1.3.5-1.7.8-3.6 1.1-5.4-.9-.3-1.8-1.2-2.7-2.3-.9-.9-2.2-1.1-4.1-.3-.8.6-1.5 1.2-2.4.7-1.5.1-2.3-.3-1.5-1.6.5-.7.7-1.6.5-2.8.1-.8.3-1.6 1-2.4-.5-.5-.8-.9-1-1.4-.2-.6.4-.5 2 .3 1.2-.7 4 0 6.9.6",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }));
};
export default SvgReproduction;